import { useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { TestimonialCard } from "./TestimonialCard";

export const TestimonialCarousel = ({ items }) => {
  const ref = useRef(null);
  const [idx, setIdx] = useState(0);
  const paused = useRef(false);

  const scrollTo = (i) => {
    const el = ref.current; if (!el) return;
    const n = ((i % items.length) + items.length) % items.length;
    const card = el.children[n]; if (card) el.scrollTo({ left: card.offsetLeft - el.offsetLeft, behavior: "smooth" });
    setIdx(n);
  };
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const t = setInterval(() => { if (!paused.current && !document.hidden) scrollTo(idx + 1); }, 5500);
    return () => clearInterval(t);
  }, [idx]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div data-testid="testimonial-carousel" className="relative" onMouseEnter={() => (paused.current = true)} onMouseLeave={() => (paused.current = false)} onTouchStart={() => (paused.current = true)}>
      <div ref={ref} className="flex snap-x snap-mandatory gap-6 overflow-x-auto scroll-smooth pb-2 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" onScroll={(e) => { const el = e.currentTarget; const w = el.children[0]?.offsetWidth || 1; setIdx(Math.round(el.scrollLeft / (w + 24))); }}>
        {items.map((t, i) => (
          <div key={t.id} className="w-[85%] shrink-0 snap-start sm:w-[calc(50%-12px)] lg:w-[calc(33.333%-16px)] lg:max-w-[380px]"><TestimonialCard t={t} index={i} /></div>
        ))}
      </div>
      <div className="mt-6 flex items-center justify-center gap-4">
        <button type="button" aria-label="Previous testimonials" data-testid="testimonials-prev" onClick={() => scrollTo(idx - 1)} className="rounded-full border border-black/15 p-2 transition-colors hover:border-en-teal hover:text-en-teal"><ChevronLeft className="h-4 w-4" /></button>
        <div className="flex gap-2">{items.map((t, i) => <button key={t.id} type="button" aria-label={`Go to testimonial ${i + 1}`} data-testid={`testimonials-dot-${i}`} onClick={() => scrollTo(i)} className={`h-2 rounded-full transition-[width,background-color] duration-300 ${i === idx ? "w-6 bg-en-teal" : "w-2 bg-black/20"}`} />)}</div>
        <button type="button" aria-label="Next testimonials" data-testid="testimonials-next" onClick={() => scrollTo(idx + 1)} className="rounded-full border border-black/15 p-2 transition-colors hover:border-en-teal hover:text-en-teal"><ChevronRight className="h-4 w-4" /></button>
      </div>
    </div>
  );
};
